import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { ContratosAll } from './components/ContratosAll';

export default function ContratosSearch() {
    return (
        <MainContent
            component={<ContratosAll />}
            titulo='Gestión de contrato'
            noBackground
            tableMaxWidth
        />
    );

};
